export default __webpack_public_path__ + "static/media/fact_sheet50.03d6c7b1.png";